export default "__VITE_ASSET__CcHjTS6f__"